import { dimension } from '@alfa-bank/newclick-alfa-metrics';

export const alfaMetricsConfig = {
    OPEN_MONEY_POOL_LANDING: {
        category: 'Money pool landing v2',
        label: 'Landing screen',
        action: 'Screen View',
        deviceScreenName: 'Money pool landing screen',
        dimensions: {
            publicId: dimension<string>(1),
            categoryName: dimension<string>(2),
            dueDate: dimension<string | undefined>(3),
            totalSum: dimension<string>(4),
            goalSum: dimension<string | undefined>(5),
            comment: dimension<string | undefined>(6),
        },
    },
    TRANSFER_BUTTON_CLICK: {
        category: 'Money pool landing v2',
        label: 'Transfer button',
        action: 'Click',
        deviceScreenName: 'Money pool landing screen',
        dimensions: {
            publicId: dimension<string>(1),
            transferSum: dimension<string>(7),
        },
    },
    TRANSFER_AMOUNT_VALIDATION_ERROR: {
        category: 'Money pool landing v2',
        label: 'Transfer amount validation',
        action: 'Error',
        deviceScreenName: 'Money pool landing screen',
        dimensions: {
            publicId: dimension<string>(1),
            transferSum: dimension<string>(7),
        },
    },
};

/* eslint-disable @typescript-eslint/no-empty-interface */
declare module '@alfa-bank/newclick-alfa-metrics/config-type' {
    type AnalyticsConfigType = typeof alfaMetricsConfig;
    interface AlfaMetricsEventsConfig extends AnalyticsConfigType {}
}
